<template>
    <div>
        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.taxes_payable_by_insured"
                    class="required"
                    label="Taxes payable by Insured & administered by Insurer(s)"
                    required
                    suffix="%"
                    placeholder=" "
                    :rules="[
                        v => ruleRequired(v, 'Taxes payable by Insured & administered by Insurer(s)')
                    ]"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.taxes_payable_by_insurer"
                    class="required"
                    label="Taxes payable and administered by Insurer(s)"
                    required
                    suffix="%"
                    placeholder=" "
                    :rules="[
                        v => ruleRequired(v, 'Taxes payable and administered by Insurer(s)')
                    ]"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.taxes_payable_by_insurer_and_administered_by_the_insured"
                    class="required"
                    label="Taxes payable by Insurer(s) and administered by the Insured or their agent"
                    required
                    suffix="%"
                    placeholder=" "
                    :rules="[
                        v => ruleRequired(v, 'Taxes payable by Insurer(s) and administered by the Insured or their agent')
                    ]"
                />
            </x-flex>
        </x-layout>

        <x-layout mb-3>
            <x-flex xs12>
                <x-text-field
                    v-model="submissionData.taxes_payable_and_administered_by_the_insured"
                    class="required"
                    label="Taxes payable and administered by the Insured or their agent"
                    required
                    suffix="%"
                    placeholder=" "
                    :rules="[
                        v => ruleRequired(v, 'Taxes payable and administered by the Insured or their agent')
                    ]"
                />
            </x-flex>
        </x-layout>
    </div>
</template>

<script>
import rules from '~/mixins/rules';

export default {
    name: "TaxesQuestions",
    mixins: [rules],
    props: {
        submissionData: {
            type: Object,
            required: true
        }
    },
}
</script>
